module.exports = (__webpack_require__(76786))(1020);